import { applyFilters } from '@wordpress/hooks';
import { useSelect, select, dispatch, withSelect } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { TabPanel, PanelRow, ToggleControl, RadioControl, Popover, Button, TextControl, Modal, SelectControl, CheckboxControl, TextareaControl, FormTokenField } from '@wordpress/components';
import { ReactSortable } from 'react-sortablejs';

import { useState, useEffect } from '@wordpress/element';

export default (props) => {
    
    const settings = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { updateSettings } = dispatch('WPTravel/Admin');
    const {field_editors} = settings
    
    return <div className="wp-travel-settings-enquiry">

        {'undefined' != typeof field_editors &&  'undefined' != typeof field_editors.enquiry && field_editors.enquiry.length > 0 &&
            <>
                {props.WPTravelFieldEditorPopover('enquiry')}
                <div className="components-panel__row wp-travel-action-section">
                    <span><Button isSecondary onClick={() => props.toggleVisible()}>{ _wp_travel.setting_strings.field_editor.add_field }</Button></span>
                    <Button isSecondary onClick={() => props.resetFields('enquiry')}>{ _wp_travel.setting_strings.field_editor.reset_field }</Button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <td></td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_label}</td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_name}</td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_type}</td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_action}</td>
                        </tr>
                    </thead>
                    <ReactSortable
                        list={field_editors.enquiry}
                        setList={sortedList => props.sortFields( sortedList, 'enquiry')}
                        handle=".account-detail-sortable"
                        tag="tbody"
                        >
                            {field_editors.enquiry.map( ( enquiryField, index ) => {
                                
                                return <tr key={index}>
                                    <td>
                                        <span className="account-detail-sortable dashicons dashicons-menu" ></span>
                                    </td>
                                    <td>
                                        {enquiryField.label}
                                    </td>
                                    <td>
                                        {enquiryField.name}
                                    </td>
                                    <td style={{textTransform: 'capitalize'}}>
                                        {enquiryField.type.replace( '_', ' ' )}
                                    </td>
                                    <td>
                                        <Button isSecondary onClick={() => {
                                            props.toggleVisible(enquiryField.name, 'enquiry')
                                        }}>{ _wp_travel.setting_strings.field_editor.field_editor_edit }</Button>
                                        { ( 'undefined' == typeof enquiryField._default || ( 'undefined' != typeof enquiryField._default && ! enquiryField._default ) ) &&
                                            <Button className="wp-traval-button-danger" isSecondary onClick={ () => {

                                                if ( window.confirm('Are you sure to delete this field?') ) {
                                                    let _enquiry_fields = [];
                                                    _enquiry_fields = field_editors.enquiry.filter((e, newIndex) => {
                                                        return newIndex != index;
                                                    });
                                                    updateSettings({ settings, field_editors:{ ...settings.field_editors, enquiry: JSON.parse(JSON.stringify(_enquiry_fields)) }  })
                                                }
                                            } }>{ _wp_travel.setting_strings.field_editor.field_editor_delete }</Button>
                                        }
                                    </td>
                                    
                                </tr>
                            } )}
                    </ReactSortable>
                </table>
                <div className="components-panel__row wp-travel-action-section">
                    <span><Button isSecondary onClick={() => props.toggleVisible()}>{_wp_travel.setting_strings.field_editor.add_field }</Button></span>
                    <Button isSecondary onClick={() => props.resetFields('enquiry')}>{ _wp_travel.setting_strings.field_editor.reset_field }</Button>
                </div>
            </>
        }
    </div>
}
